import Layer from './layer';

export default class ImageLayer extends Layer {
  constructor(page, image) {
    super(page);
    this.type = 'image';

    if (image === undefined)
      return;

    this.width = image.width;
    this.height = image.height;

    this.canvas = document.createElement('canvas');
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    let ctx = this.canvas.getContext('2d');
    ctx.drawImage(image, 0, 0);
  }
}
